// typography specifications go here

const typography = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em",
  },

  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    "3": ".75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "7": "1.75rem",
    "8": "2rem",
    "9": "2.25rem",
    "10": "2.5rem",
  },

  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },

  fonts: {
    heading: "Poppins",
    body: "Poppins",
    mono: "Courier Prime",
  },

  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem",
    // design system font sizes
    h1: "1.5rem",
    h2: "1.13rem",
    h3: "1.13rem",
    h4: "0.875rem",
    h5: "1.0rem",
    h6: "0.75rem",
    p: "0.875rem",
    // following sizes based on 10px = 1rem
    //   h1: "2.4rem",
    //   h2: "1.8rem",
    //   h3: "1.8rem",
    //   h4: "1.4rem",
    //   h5: "1.6rem",
    //   h6: "1.2rem",
    //   p: "1.4rem",
  },
}

export default typography
